import api from "../helpers/api";
import { ToastChakra } from "../helpers/toast";

const baseURL = process.env.REACT_APP_API_URL;

const getAllFacturas = async (data) => {
    const { page, perPage } = data;
    const response = await api.get(`${baseURL}/factura_venta/listar?pagina=${page}&cantidadPagina=${perPage}`);
  //  console.log('esto trae facturas :', response.data);
    return response.data;  // Aquí obtienes el objeto con `data` y `pagination`
}

const createFactura = async (data) => {
    const response = await api.post(`${baseURL}/factura_venta/crear`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('FACTURA CREADA', 'La factura se ha creado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

const updateFactura = async (data) => {
    //console.log("Datos enviados al backend desde el servicio:", data); // Depuración
    const response = await api.put(`${baseURL}/factura_venta/modificar/${data.id}`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('FACTURA MODIFICADA', 'La factura se ha modificado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
};


const deleteFactura = async (id) => {
    const response = await api.delete(`${baseURL}/factura_venta/eliminar/${id}`);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('FACTURA ELIMINADA', 'La factura se ha eliminado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

const getFacturaById = async (id) => {
    const response = await api.get(`${baseURL}/factura_venta/listar/${id}`);
    if (response.status === 200 || response.status === 201) {
        //console.log('esto trae facturasbyId :', response.data);
        return response.data;
    }
}


const facturasVentasService = {
    getAllFacturas,
    createFactura,
    updateFactura,
    deleteFactura,
    getFacturaById
}

export default facturasVentasService;
